import { Sentry } from "@/instrument";

type AsyncErrorHandlerOptions = {
  setIsSubmitting: (loading: boolean) => void;
  onError?: (error: unknown) => void;
  errorContext: string;
};

export async function handleAsyncAction(
  action: () => Promise<void>,
  { setIsSubmitting, onError, errorContext }: AsyncErrorHandlerOptions,
): Promise<void> {
  try {
    setIsSubmitting(true);
    await action();
  }
  catch (error) {
    Sentry.captureException(error);
    console.error(`Failed to ${errorContext}:`, error);
    onError?.(error);
  }
  finally {
    setIsSubmitting(false);
  }
}
